module.exports = __webpack_public_path__ + "3777e603786c7b45dd77bf11a66dea28.svg";